export default __webpack_public_path__ + "static/media/logo@2x.fbdc5b3f.png";